import { createSpace } from './firestore';

// The renovation zones for 401 Amalfi Dr. Fixed doc ids make seeding
// idempotent — re-running just overwrites the same docs.
export const SPACE_SEEDS = [
  // Interior — named by room (see data/rooms.js for the room-page grouping).
  { id: 'bedroom-1', name: 'Master Room', category: 'interior', icon: '🛏', description: 'Master suite bedroom — furniture configuration', sortOrder: 10 },
  { id: 'bedroom-2', name: 'East Bedroom', category: 'interior', icon: '🛏', description: 'Furniture configuration', sortOrder: 11 },
  { id: 'bedroom-3', name: 'South Bedroom', category: 'interior', icon: '🛏', description: '16′ × 10′8″ nominal, 98.5″ ceiling (S→N long axis) — furniture configuration', sortOrder: 12 },
  { id: 'bedroom-4', name: 'North Bedroom', category: 'interior', icon: '🛏', description: 'Furniture configuration', sortOrder: 13 },
  { id: 'bathroom-1', name: 'Master Bath', category: 'interior', icon: '🛁', description: 'Bathtub shower in — furnishing stage', sortOrder: 20 },
  { id: 'bathroom-2', name: 'East Bathroom', category: 'interior', icon: '🛁', description: 'Walk-in shower, no tub — 9′ × 5′ nominal, 98.5″ ceiling (S→N long axis)', sortOrder: 21 },
  { id: 'bathroom-3', name: 'South Bathroom', category: 'interior', icon: '🛁', description: 'Walk-in shower, no tub — 9′ × 5′ nominal, 98.5″ ceiling (S→N long axis)', sortOrder: 22 },
  { id: 'bathroom-4', name: 'North Bathroom', category: 'interior', icon: '🛁', description: 'Walk-in shower, no tub — 9′ × 5′ nominal; sloped ceiling from 140″ (S side), false ceiling removed', sortOrder: 23 },
  { id: 'powder-room', name: 'Entrance Bathroom', category: 'interior', icon: '🚪', description: 'Off the living room — sink, cabinet + toilet, no shower', sortOrder: 24 },
  // Outdoor
  { id: 'pool', name: 'Pool', category: 'outdoor', icon: '🏊', description: 'Pool renovation', sortOrder: 30 },
  { id: 'sauna', name: 'Sauna', category: 'outdoor', icon: '🧖', description: 'New sauna build', sortOrder: 31 },
  { id: 'outdoor-showers', name: 'Outdoor Showers', category: 'outdoor', icon: '🚿', description: 'New outdoor showers', sortOrder: 32 },
  { id: 'front-yard', name: 'Front Yard', category: 'outdoor', icon: '🌳', description: 'Landscape redo', sortOrder: 33 },
  { id: 'back-yard', name: 'Back Yard', category: 'outdoor', icon: '🌿', description: 'Landscape redo', sortOrder: 34 },
  // Exterior / structures
  { id: 'exterior', name: 'House Exterior', category: 'exterior', icon: '🏠', description: 'Facade, trim, paint — partial redo', sortOrder: 40 },
  { id: 'garage', name: 'Garage', category: 'exterior', icon: '🚗', description: 'Garage renovation', sortOrder: 41 },
];

export const CATEGORY_LABELS = {
  interior: 'Interior',
  outdoor: 'Outdoor & Landscape',
  exterior: 'Exterior & Structures',
};

export async function seedSpaces() {
  for (const seed of SPACE_SEEDS) {
    // eslint-disable-next-line no-await-in-loop
    await createSpace(seed);
  }
}
